// File: src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import RequestPage from './Pages/Request/index';
import HomePage from './Pages/Home/index';
import Footer from './Footer';
import { Container, Navbar, Nav } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './assets/chirptasklogo-white-horizontal.png'

function App() {
  return (
    <Router>
      <Navbar bg="light" variant="light" expand="lg" style={{position: 'sticky', top: 0, boxShadow: '2px 2px 10px #999', zIndex: 1000}}>
        <Container>
          <Navbar.Brand as={Link} to="/">
            <img height="75" src={logo} alt="ChirpTask Logo" />
          </Navbar.Brand>
          {/*<Nav className="me-auto">
            <Nav.Link as={Link} to="/request">Request (demo only)</Nav.Link>
          </Nav>*/}
        </Container>
      </Navbar>

      <div className="container-fluid px-0 mx-0">
        <Routes>
          <Route path="/request" element={<RequestPage />} />
          <Route path="/" element={<HomePage />} />
        </Routes>
      </div>

      <Footer />
    </Router>
  );
}

export default App;